import Vue from 'vue'
import Vuex from 'vuex'
import users from 'store/modules/users'
import home from './modules/home'
import getters from 'store/getters'
import routes from './modules/routes'
import samples from './modules/samples'
import reagent from './modules/reagent'
import experiments from './modules/experiments'
import project1 from './modules/project1'
import audit from './modules/admin/audit'
import tagsView from './modules/tagsViews'
import cv from './modules/cv'
// import analysisI from './modules/analysisI'
import ods from './modules/ods'
import datasetSelector from './modules/datasetSelector'
//admin
import lab from './modules/admin/lab'
import message from './modules/admin/message'
import upload from './modules/upload'
// search
import search from './modules/search'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    users,
    home,
    routes,
    samples,
    reagent,
    experiments,
    lab,
    project1,
    audit,
    message,
    upload,
    tagsView,
    cv,
    search,
    // analysisI,
    ods,
    datasetSelector
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js